import { companyImage } from '@/utils/common/env.constants';
import { Typography } from '@pwskills/rachnaui';
import React, { useEffect, useState } from 'react';
// import Lottie from 'react-lottie';
import Image from 'next/image';
import Zoom from '@/components/common/Icons/courseDescription/Zoom';
import Cloud from '@/components/common/Icons/courseDescription/Cloud';
import dynamic from 'next/dynamic';
import rocket from '../../../../assets/Lottie/rocket.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });
type Props = {
  certificate: string;
  setModelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isAmateur: boolean;
};

const CertificateSection = (props: Props) => {
  const { certificate, setModelOpen, isAmateur } = props;
  const [certificateId, setCertificateId] = useState(certificate);
  // to fix previous certificate issue
  const timestamp = Date.now();
  useEffect(() => {
    setCertificateId(certificate);
  }, [certificate]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: rocket,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <section className="flex flex-col items-center gap-y-4 w-full">
      <div className="flex justify-center items-center w-full">
        {!isAmateur ? (
          <div className="relative !w-[80%] large:!w-[300px] h-[310px] medium:!h-[410px]">
            <Image
              src={`${companyImage}/certificateImage/${certificateId}?timestamp=${timestamp}`}
              alt="certificate"
              fill
              unoptimized
              className="bg-blue-50 p-4 rounded-lg shadow-dark object-contain z-10"
            />
            <figure className="hidden large:!inline-block absolute right-0 bottom-0 translate-x-[60%] z-0">
              <Lottie
                options={defaultOptions}
                width={192}
                height={192}
                style={{
                  cursor: 'default',
                }}
              />
            </figure>
            <Cloud className="hidden large:!inline-block absolute top-[100px] translate-x-16 translate-y-4 right-0 w-20 h-20" />
          </div>
        ) : (
          <div className="relative w-[208px] h-[224px] medium:w-[250px] medium:h-[270px] large:w-[382px] large:h-[410px] hover:opacity-70">
            <img
              src="/images/courseDescription/CertificateFrame.webp"
              alt={certificate}
              width={386}
              height={273}
              className=""
            />
            <Image
              src={`${companyImage}/certificateImage/${certificateId}?timestamp=${timestamp}`}
              alt="certificate"
              width={386}
              height={273}
              unoptimized
              className="rounded-lg z-10 !w-[210px] !h-[150px] medium:!w-[254px] medium:!h-[180px] large:!w-[386px] large:!h-[273px] absolute top-1/2 right-[22px] medium:right-[25px] large:right-[40px] transform -translate-y-1/2"
              onClick={() => setModelOpen(true)}
            />
            <div
              className="absolute hidden medium:!flex !w-[210px] !h-[150px] medium:!w-[254px] medium:!h-[180px] large:!w-[386px] large:!h-[273px] gap-1 items-center justify-center right-[22px] medium:right-[25px] large:right-[40px] top-[50%] bg-black opacity-0 hover:opacity-[0.7] z-[1111] transform -translate-y-1/2 "
              onClick={() => setModelOpen(true)}
              aria-hidden="true"
            >
              <div className="flex gap-1 items-center justify-center cursor-pointer">
                <Zoom textColor="#ffffff" />
                <Typography component="body-regular" variant="semi-bold" className="text-white">
                  Click to zoom
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>

      {!isAmateur && (
        <button
          type="button"
          className="flex gap-1 items-center justify-center cursor-pointer "
          onClick={() => setModelOpen(true)}
        >
          <Zoom className="text-gray-650" />
          <Typography
            component="body-regular"
            variant="semi-bold"
            className="underline underline-offset-4 text-gray-650"
          >
            Click to zoom
          </Typography>
        </button>
      )}
    </section>
  );
};

export default CertificateSection;
